"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.object.keys.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _AssetSnippet = _interopRequireDefault(require("./components/AssetSnippet"));

var _getAssetsCoin = require("./common/getAssetsCoin");

var _Title = _interopRequireDefault(require("./components/Title"));

var _index = require("@/model/assets/index");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getCoinList } from "@/model/assets/index";
var refreshTime = 5000;
var _default = {
  data: function data() {
    return {
      coinData: {},
      // 币种数据列表
      assetsList: {},
      // 资产数据列表
      assetsListTimer: null
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getItemList();

            case 2:
              _context.next = 4;
              return (0, _getAssetsCoin.getAssetsData)();

            case 4:
              _this.assetsList = _context.sent;

              _this.loopRefreshAssets();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.assetsListTimer);
  },
  destroyed: function destroyed() {
    clearInterval(this.assetsListTimer);
  },
  computed: {
    sortCoinData: function sortCoinData() {
      return this.sortObj(this.coinData); // return this.coinData;
    }
  },
  methods: {
    sortObj: function sortObj(obj) {
      if (obj[10007]) {
        obj[10007].order_by = -1;
      }

      var keys = Object.keys(obj).sort(function (a, b) {
        return obj[a].order_by - obj[b].order_by;
      });
      var newObj = [];

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        newObj.push(obj[key]);
      }

      return newObj;
    },
    getItemList: function getItemList() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$getCoinList, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = {
                  __version: "3.4.3",
                  __channel: "2"
                };
                _context2.next = 3;
                return (0, _index.getStaticCoinList)(req);

              case 3:
                _yield$getCoinList = _context2.sent;
                status = _yield$getCoinList.status;
                data = _yield$getCoinList.data;

                if (status == 200) {
                  _this2.coinData = data;
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loopRefreshAssets: function loopRefreshAssets() {
      var _this3 = this;

      this.assetsListTimer = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _getAssetsCoin.getAssetsData)();

              case 2:
                return _context3.abrupt("return", _this3.assetsList = _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })), refreshTime);
    }
  },
  components: {
    TopTitle: _Title.default,
    AssetSnippet: _AssetSnippet.default
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    clearInterval(this.assetsListTimer);
    next();
  }
};
exports.default = _default;